import eventMessage from 'src/components/event-message';
import { HB_EVENT_NAME, PAGE_START_TIME } from 'src/constant';
import EVENT_MSG_TYPE from 'src/constant/event-msg-type';
import getPaintInfo from './paint';

/**
 * 获取navigation加载数据
 * @returns Promise<Record<string, any>>
 */
function getNavgationInfo(): Promise<Record<string, any>> {
  const navObj: any = {};
  return new Promise((resolve) => {
    const collect = () => {
      requestAnimationFrame(() => {
        const [entry] = performance.getEntriesByType('navigation');
        if (entry) {
          navObj.timing = entry.toJSON();
          navObj.ttfb = Math.round(entry.responseStart - entry.fetchStart);
          navObj.dcl = Math.round(entry.domContentLoadedEventStart);
          navObj.tld = Math.round(entry.loadEventStart);
          navObj.navtype = entry.type;

          resolve(navObj);
        }
      });
    };

    if (document.readyState === 'complete') {
      collect();
    } else {
      window.addEventListener('load', collect);
    }
  }).catch(() => navObj);
}

export default async function pageNavPerfCollect() {
  const perData: any = {};
  const navInfo = await getNavgationInfo();
  Object.assign(perData, navInfo);
  eventMessage.publish({
    time: PAGE_START_TIME,
    type: EVENT_MSG_TYPE.PAGEVIEW,
    data: perData,
  });

  const paintInfo = await getPaintInfo();
  const perfKey = ['ttfb', 'dcl', 'tld', 'fb', 'fcp'];
  Object.assign(perData, paintInfo);

  // 性能指标数据拆出单独性能事件上报
  // PAGEVIEW事件暂时继续保留相关字段，后续会从PAGEVIEW中去除
  perfKey.forEach(key => {
    if(perData[key]) {
      eventMessage.publish<HBEventData<HBPerf>>({
        time: PAGE_START_TIME + perData[key],
        type: EVENT_MSG_TYPE.OTHER,
        data: {
          en: HB_EVENT_NAME.PERF,
          pkey: key,
          pval: perData[key],
        },
      });
    }
  });
}
